var jq = jQuery.noConflict();

var companyVars = JSON.parse(document.getElementById("companyVars").innerText),
    asset_url = companyVars.asset_url,
    website_base_url = companyVars.website_base_url,
    ir_base_url = companyVars.ir_base_url,
    hCaptchaSiteKey = companyVars.hCaptchaSiteKey,
    isQmod = companyVars.isQmod,
    autorefresh = companyVars.autorefresh;

// Fires on click or enter keypress
jq.fn.accessibleClick = function (handler) {
    jq(this).on('click keyup', function (event) {
        if (event.type === 'keyup') {
            var code = event.which;
            // Don't consider it a click if we don't press enter or spacebar
            if ((code !== 32) && (code !== 13)) {
                return false;
            }
        }
        handler.call(this, event);
    });
};

/** Wait for a selector to match an element (MutationObserver). Used by news slider a11y (CT-675). */
function waitForElm(selector) {
    return new Promise(function (resolve) {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }
        var observer = new MutationObserver(function () {
            if (document.querySelector(selector)) {
                resolve(document.querySelector(selector));
                observer.disconnect();
            }
        });
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
}

var captchaIDs = {}; // Holds all hCaptcha elements so that we can use the correct response when there are multiples on a page
function hCaptchaOnLoad () {
    // Add hcaptcha to all forms on a page
     jq('.h-captcha').each(function () {
        var form = jq(this).closest('form');
        window.captchaIDs[form[0].id] = hcaptcha.render(this.id, {
            "sitekey" : window.hCaptchaSiteKey,
            "callback": function (token) {
                jq('<input>', {
                    type: 'hidden',
                    name: 'h-captcha-response',
                    value: token
                }).appendTo(form);
                form.submit();
            }
        });
    });
}

// Main document ready scripts
jq(document).ready(function () {
    // Pagination
    const paginationMobile = jq('#pagination--mobile');
    if (paginationMobile.length) {
        jq(this).find('#pagination--mobile-select').change(function() {
            var selectedPage = jq(this).val();
            location.href = encodeURI(selectedPage);
        });
    }

    // Add noopener to all links that open in a new tab.
    jq('a[target="_blank"]').each(function () {
        var linkRel = jq(this).attr('rel');
        if (!linkRel || (linkRel && linkRel.indexOf('noopener') == -1)) {
            var newRel = linkRel === undefined ? '' : linkRel;
            newRel += linkRel && linkRel.length ? ' noopener' : 'noopener';
            jq(this).attr('rel', newRel);
        }
        // Add descriptive text for screen readers if there's not already a title attr set
        if (this.getAttribute('title') === null) {
            this.setAttribute('title', 'Opens in a new window');
        }
    });
    addRequiredAsteriskToLabels();
    
    // Scroll more home hero button
    var scrollMore = document.getElementById("scroll-more");
    if (scrollMore) {
        jq(scrollMore).accessibleClick(function (e) {
            e.preventDefault();
            var target = jq(this).closest(".home-hero").siblings(".module").first();
            
            // make scroll distance larger for mobile devices, when the navigation bar is not in a fixed position
            let header = document.querySelector("#header");
            var animationDistance = (window.innerWidth <= 991 && header && window.getComputedStyle(header).getPropertyValue("position") !== "fixed") ? 0 : jq("#header").height(); 
            jq("html,body").animate({
                scrollTop: target.offset().top - animationDistance
            }, "slow");
        });
        
        // add a resize event listener to recheck the screen width
        window.addEventListener("resize", function() {
            // make scroll distance larger for mobile devices, when the navigation bar is not in a fixed position
            let header = document.querySelector("#header");
            var animationDistance = (window.innerWidth <= 991 && header && window.getComputedStyle(header).getPropertyValue("position") !== "fixed") ? 0 : jq("#header").height(); 
            jq(scrollMore).data("animation-distance", animationDistance);
        });
    }

    var headerAffixed = document.getElementById("header");
    var subNavAffixed = document.querySelector(".sub-navigation.affixed");
    if (
        (headerAffixed && headerAffixed.classList.contains("affixed")) ||
        subNavAffixed
    ) {
        var scrollNavLastTop = 0;
        var scrollNavThreshold = 1;
        var scrollNavDelta = 5;
        var scrollNavLgBreakpoint = 992;
        var subNavAffixOffset = null;

        function recalculateSubNavAffixOffset() {
            if (!subNavAffixed) {
                return;
            }

            var header = document.getElementById("header");
            var headerHeight = header ? header.offsetHeight : 0;
            var wrapper = subNavAffixed.closest(".sub-navigation-wrapper");
            var measureEl = wrapper || subNavAffixed;
            var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            var measureTop = measureEl.getBoundingClientRect().top + scrollTop;

            subNavAffixOffset = measureTop - headerHeight;
        }

        function updateSubnavFixedTop() {
            if (!subNavAffixed) {
                return;
            }

            var header = document.getElementById("header");
            var offset = 0;

            if (
                header &&
                header.classList.contains("header-is-fixed") &&
                !header.classList.contains("header-is-hidden")
            ) {
                offset = header.offsetHeight;
            }

            subNavAffixed.style.setProperty("--subnav-fixed-top", offset + "px");
        }

        function updateNavHideDistance() {
            var header = headerAffixed;
            var hideDistance = 0;

            if (header) {
                hideDistance = header.offsetHeight;
            }

            if (
                subNavAffixed &&
                subNavAffixed.classList.contains("subnav-is-fixed")
            ) {
                hideDistance += subNavAffixed.offsetHeight;
            }

            document.documentElement.style.setProperty(
                "--nav-hide-distance",
                hideDistance + "px"
            );
        }

        function updateScrollFixedNavs() {
            if (window.innerWidth < scrollNavLgBreakpoint) {
                if (headerAffixed && headerAffixed.classList.contains("affixed")) {
                    headerAffixed.classList.remove("header-is-fixed", "header-is-hidden");
                }
                if (subNavAffixed) {
                    subNavAffixed.classList.remove("subnav-is-fixed", "subnav-is-hidden");
                    subNavAffixed.style.removeProperty("--subnav-fixed-top");
                }
                document.documentElement.style.removeProperty("--nav-hide-distance");
                return;
            }

            var scrollTop = window.pageYOffset || document.documentElement.scrollTop;

            if (headerAffixed && headerAffixed.classList.contains("affixed")) {
                if (scrollTop <= scrollNavThreshold) {
                    headerAffixed.classList.remove("header-is-fixed", "header-is-hidden");
                } else if (scrollTop > scrollNavLastTop + scrollNavDelta) {
                    headerAffixed.classList.add("header-is-fixed", "header-is-hidden");
                } else if (scrollTop < scrollNavLastTop - scrollNavDelta) {
                    headerAffixed.classList.remove("header-is-hidden");
                    headerAffixed.classList.add("header-is-fixed");
                }
            }

            if (subNavAffixed) {
                if (subNavAffixOffset === null) {
                    recalculateSubNavAffixOffset();
                }

                if (scrollTop <= subNavAffixOffset) {
                    subNavAffixed.classList.remove("subnav-is-fixed", "subnav-is-hidden");
                } else if (scrollTop > scrollNavLastTop + scrollNavDelta) {
                    subNavAffixed.classList.add("subnav-is-fixed", "subnav-is-hidden");
                } else if (scrollTop < scrollNavLastTop - scrollNavDelta) {
                    subNavAffixed.classList.remove("subnav-is-hidden");
                    subNavAffixed.classList.add("subnav-is-fixed");
                }

                updateSubnavFixedTop();
            }

            updateNavHideDistance();

            scrollNavLastTop = scrollTop <= 0 ? 0 : scrollTop;
        }

        if (subNavAffixed) {
            recalculateSubNavAffixOffset();
        }

        window.addEventListener("scroll", updateScrollFixedNavs, { passive: true });
        window.addEventListener("resize", function () {
            subNavAffixOffset = null;
            if (subNavAffixed) {
                recalculateSubNavAffixOffset();
            }
            updateScrollFixedNavs();
        });
        updateScrollFixedNavs();
    }
    
    //Video Play/Pause Buttons
    var videoBtns = document.querySelectorAll('.video-control-btn');
    videoBtns.forEach(function(el) {        
        // get video id from attribute 'data-target'
        var targetVideo = document.getElementById(el.dataset.target);
        if (targetVideo) {
          jq(el).click(function(e) {
            if (targetVideo.paused) {
              targetVideo.play();
              //Controls don't show by default to match designs
              //On play, we need to hide the designed play/pause button and shows the controls
              if (targetVideo.classList.contains('show-controls-on-play')) {
                el.classList.add('hide');  
                targetVideo.setAttribute('controls', '');
              }
              el.setAttribute('aria-label', 'Pause Video');
            } else {
              targetVideo.pause();
              el.setAttribute('aria-label', 'Play Video');
            }
            el.classList.toggle('paused');
          });
        }
    });
    
    //Circle Stat with Percentage Animation
    var divPercentage = jq(".stats-row-w-percents");
    if(divPercentage.length) {
        jq(document).bind("scroll", function (ev) {
            var scrollOffset = jq(document).scrollTop();
            var containerOffset = jq(".stats-row-w-percents").offset().top - window.innerHeight;
            if (scrollOffset > containerOffset) {
                jq(".stats-row-w-percents .stat").each(function () {
                    var percDiv = jq(this).find(".number"),
                    svgElm = jq(this).find(".circle"),
                    percentNumber = jq(this).attr("data-percent");
                    svgElm.attr("stroke-dasharray", percentNumber + ", 100");
                    svgElm.addClass("active");
                    jq({percentage: 0}).stop(true).animate({percentage: percentNumber}, {
                        duration : 2000,
                        step: function () {
                        var percentageVal = Math.round(this.percentage);
                        percDiv.text(percentageVal + "%");
                    }
                    }).promise().done(function () {
                        percDiv.text(percentNumber + "%");
                    });
                });
                jq(document).unbind("scroll");
            }
        });
    }
    
    var menuRight = document.getElementById("mobile-nav"),
    showRight = document.getElementById("showRight");
    
    jq.fn.openMobileRightMenu = function() {
        toggleMenuKeybind();
        jq(".mobile-nav-trigger").toggleClass("active");
        jq("body").toggleClass("push-to-left");
        jq(menuRight).toggleClass("cbp-spmenu-open");
        disableOther("showRight");
        if (jq(".mobile-nav-trigger").hasClass('active')) {
            jq('.mobile-nav-trigger').attr('aria-label', 'Close main navigation');
            jq('.mobile-nav-trigger').attr('aria-expanded', 'true');
        } else {
            jq('.mobile-nav-trigger').attr('aria-label', 'Expand main navigation');
            jq('.mobile-nav-trigger').attr('aria-expanded', 'false');
        }
    }

    function disableOther(button) {
        if (button !== "showRight") {
            jq(showRight).toggleClass("disabled");
        }
    }
    
    /**
     * This function handles keydown events when a full screen nav is present, allowing
     * the navigation to be closed by pressing the esc key
     */
     function toggleMenuKeybind() {
        var $body = jq('body');    
        if ($body.hasClass('push-to-left')) {
            $body.off("keydown");
        } else {
            $body.on("keydown", function (e) {
                if (e.which == 27) {
                    jq(".main-nav").toggleClass("active");
                    jq(showRight).toggleClass('active');
                    jq("body").toggleClass("push-to-left");
                    jq(menuRight).toggleClass("cbp-spmenu-open");
                    disableOther("showRight");
                    $body.off("keydown");
                }
            });
        }
    }

    // Basic Form Validation
    var validator = jq(".validate-form");
    validator.each(function () {
        var $form = jq(this);
        var formID = $form.attr('id');
        jq(this).validate({
            rules: {
                password_confirm: {
                    equalTo: "#password",
                }
            },
            messages: {
                password_confirm: {
                    equalTo: "Passwords must be the same"
                }
            },
            errorPlacement: function (error, element) {
                if (element.attr("type") == "radio") {
                    error.prependTo(element.parent());
                } else {
                    error.appendTo(element.parent());
                }
            },
            submitHandler: function (form) {
                if (hcaptcha.getResponse(window.captchaIDs[formID])) {
                    form.submit();
                } else {
                    hcaptcha.reset(window.captchaIDs[formID]);
                    hcaptcha.execute(window.captchaIDs[formID]);
                }
            },
            // Scroll and focus on the 1st error input after submitting an invalid form 
            invalidHandler: function(event, validator) {
                if (validator.errorList.length >= 1) {
                    let errorElement = validator.errorList[0].element;
                    errorElement.scrollIntoView({ behavior: 'instant', block: 'center' });
                    errorElement.focus();
                }
            }
        });
    });
    
    jq.validator.methods.email = function (value, element) {
      return this.optional(element) || /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(value);
    }
    
    //File input
    var fileInput = jq(".file-text input");
    fileInput.change(function (e){
        $this = jq(this);
        var val = $this.val().split("\\");
        var length = val.length;
        var filename = val[length-1];
        jq(this).parent(".file-text").children(".text-wrapper").text(filename);
    });

    // SEC Filing Filters - auto submit form
    jq("#sec-filing-filter select").on("change", function (e) {
        jq(this).closest("form").submit(); 
    });
    
    var $filterSelect = jq(".row-filter .eq-select");
    if ($filterSelect.length) {
        $filterSelect.on("change", function () {
            var url = window.location.protocol + "//" + window.location.hostname + window.location.pathname;
            var query = "";
            jq(".row-filter .eq-select").each(function () {
                var prefix = "&";
                if (query.length === 0) {
                    prefix = "?";
                }
                if (jq(this).val() != -1) {
                    query += prefix + jq(this).attr("name") + "=" + jq(this).val();
                }
            });
            url = url + query;
            if (!query) {
            	var full_url = url + "?year=" + jq(this).val();
            	if (window.location.href != full_url) {
            		window.location.href = full_url;
            	}
            } else {
            	if (window.location.href != url) {
            		window.location.href = url;
            	}
            }
       });
    }
    
    // Resources module
    if (jq(".module-resources-page").length) {
        var viewModel = new ViewModel(JSON.parse(document.getElementById("resourcesVm").innerText));
    }
    
    // News slider
    if (jq(".news-slider").length) {
        jq(".news-slider").slick(JSON.parse(document.getElementById("newsSlickOptions").innerText));
        waitForElm(".news-slider.slick-initialized").then(function () {
            var $slider = jq(".news-slider");
            function newsSliderUpdateDotAriaSelected() {
                waitForElm(".module-latest-news-slider .slider-nav .eq-dots .slick-dots li").then(function () {
                    jq(".module-latest-news-slider .slider-nav .eq-dots .slick-dots li").each(function () {
                        var $btn = jq(this).find("button");
                        var isActive = jq(this).hasClass("slick-active") && jq(this).hasClass("active");
                        $btn.attr("aria-selected", isActive ? "true" : "false");
                    });
                });
            }
            $slider.on("afterChange", newsSliderUpdateDotAriaSelected);
            newsSliderUpdateDotAriaSelected();
        });
    }

    // Team members slider (row-team-members-slider)
    if (jq(".team-members-slider").length) {
        var teamSliderOpts = document.getElementById("teamMembersSlickOptions");
        if (teamSliderOpts) {
            jq(".team-members-slider").slick(JSON.parse(teamSliderOpts.innerText));
        }
        // Infinite mode clones .eq-dialog links; EqDialog skips clones on init — forward clone clicks to the real trigger.
        jq(".module-team-members-slider").off("click.eqTeamBioClone").on(
            "click.eqTeamBioClone",
            ".team-members-slider .slick-cloned a.eq-dialog",
            function (e) {
                var href = this.getAttribute("href");
                if (!href || href.charAt(0) !== "#") {
                    return;
                }
                var $real = jq(".module-team-members-slider .team-members-slider .slick-slide:not(.slick-cloned) a.eq-dialog").filter(function () {
                    return jq(this).attr("href") === href;
                }).first();
                if ($real.length) {
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    $real.trigger("click");
                }
            }
        );

        // One Bio link in tab order: center slide, non-clone only (Slick infinite duplicates anchors).
        var $teamSlider = jq(".team-members-slider");
        function teamMembersSliderBioTabOrder() {
            if (!$teamSlider.hasClass("slick-initialized")) {
                return;
            }
            $teamSlider.find("a.team-member-slide__bio-link").attr("tabindex", "-1");
            $teamSlider
                .find(".slick-slide.slick-center:not(.slick-cloned) a.team-member-slide__bio-link")
                .removeAttr("tabindex");
        }
        $teamSlider.on("init reInit afterChange setPosition breakpoint", teamMembersSliderBioTabOrder);
        setTimeout(teamMembersSliderBioTabOrder, 0);
    }

    // Testimonials row (row-testimonials) — one slide per row; options script id per row
    jq(".testimonials-slider[data-slick-options-id]").each(function () {
        var slider = jq(this);
        var optsId = slider.attr("data-slick-options-id");
        var optsEl = optsId ? document.getElementById(optsId) : null;
        if (optsEl && !slider.hasClass("slick-initialized")) {
            slider.slick(JSON.parse(optsEl.innerText));
        }
    });

    // Featured insights slider (row-featured-insights-slider)
    jq(".featured-insights-slider[data-slick-options-id]").each(function () {
        var slider = jq(this);
        var optsId = slider.attr("data-slick-options-id");
        var optsEl = optsId ? document.getElementById(optsId) : null;
        if (optsEl && !slider.hasClass("slick-initialized")) {
            slider.slick(JSON.parse(optsEl.innerText));
        }
    });

    // SEC Filings expand
    jq(".spr-expandable").hide();
    jq(".spr-toggle-expandable").click(function () {
    	jq(this).next(".spr-expandable").toggle("blind");
    	jq(this).toggleClass('expanded');
    	if (jq(this).hasClass('expanded')) {
    	    jq(this).attr('aria-pressed', true);   
    	} else {
    	    jq(this).attr('aria-pressed', false);
    	}
    });
    
    // Crisis Messaging
    var $majorAnnouncement = jq('#majorAnnouncement');
    var majorAnnouncementCookieName = "eqMajorAnnouncement";
    if ($majorAnnouncement.length) {
        var majorAnnouncementTimestamp = $majorAnnouncement.data("timestamp");
        var majorAnnouncementCookie = Cookies.get(majorAnnouncementCookieName);
        if (majorAnnouncementCookie != majorAnnouncementTimestamp) {
            let announcements = new EqDialog({
                show_close_button: true,
            });
            announcements.open('inline', 'majorAnnouncement');
            // Expires should be set to a number of days
            Cookies.set(majorAnnouncementCookieName, majorAnnouncementTimestamp, { secure: true, domain: window.location.hostname, expires: 7 });
        }
    }
    
    // Add Class to body if there is a scoll bar in the page
    if (jq(document).width() < jq(window).outerWidth()) { 
        jq('body').addClass('scrollbar');
    }
    
    function resize_events() {
        // Fix accessibility issue for main navigation and sub navigation triggers on mobile
        if (window.innerWidth <= 991) {
            jq('.mobile-nav-trigger').attr('tabindex', 0);
            jq('.mobile-sub-nav-trigger').attr('tabindex', 0);
            jq('.has-children ul li a').attr('tabindex', '-1');
            jq('.cbp-spmenu > .main-menu ul').attr('aria-hidden', 'true');
            jq('.has-children ul').attr('aria-hidden', 'true');
            jq('.cbp-spmenu > .main-menu > li > ul').attr('aria-hidden', 'true');
            if (jq('.cbp-spmenu').hasClass('cbp-spmenu-open')) {
                jq('.cbp-spmenu > .main-menu > li > a').attr('tabindex', 0);
            } else {
                jq('.cbp-spmenu > .main-menu > li > a').attr('tabindex', -1);
            }
        } else {
            jq('.mobile-nav-trigger').attr('tabindex', '');
            jq('.mobile-sub-nav-trigger').attr('tabindex', '');
            jq('.has-children ul li a').attr('tabindex', '');
            jq('.has-children ul').attr('aria-hidden', 'false');
            jq('.cbp-spmenu > .main-menu > li > ul').attr('aria-hidden', 'false');
            jq('.cbp-spmenu > .main-menu > li > a').attr('tabindex', 0);
        }
        // Add scroll to tables that would get out of bounds and update shadows as needed
        applyScrollToTables();
        jq(".scroll .table-figure").on("scroll", updateShadowsInTables);
        updateShadowsInTables();
    }
    // Wrap article news in table-wrapper to prevent it from breaking on mobile
    jq('.full-news-article table').each(function(ind){
        let title = 'Table ' + (ind + 1);
        jq(this).wrap(`<div class="table-wrapper"><figure class="table-figure" tabindex="0" aria-label="${title}"></figure></div>`);
    });
    // Add elements to table wrappers for mobile styling
    jq('.table-figure').each(function() {
        let wrap = jq(this).closest('.table-wrapper');
        
        wrap.prepend('<span class="left-shadow-block"></span>');
        wrap.append('<span class="right-shadow-block"></span>');

    });
    // Call resize_events() on load
    resize_events();

    jq(window).resize(function(evt) {
        resize_events();
    });
    
    // Enable accessible clicking on mobile navs and subnavs
    jq('.mobile-nav-trigger').on('click', function(evt) {
        evt.stopPropagation();
        jq(this).openMobileRightMenu();
        resize_events();
        return false;
    });
    // Close mobile nav when selecting the darkened body background
    jq('.cbp-spmenu').accessibleClick(function(evt) {
        evt.stopPropagation();
    });
    jq('body').on('click', function(evt) {
        if (this.classList.contains("push-to-left") ) {
            jq(this).openMobileRightMenu();
            resize_events();
            return false;
        };
    }); 
    
    // Detect window size change (switching to landscape on tablet
    var windowW = window.innerWidth;
    jq(window).resize(function() {
        windowW = window.innerWidth;
    });
    
    // Close mobile nav after selecting anchor link, make selected link use active class
    jq('.main-menu > .has-children > a').accessibleClick(function(e) {
        if (windowW >= 992) return;
        // Remove any existing active classes
        if (this.parentElement.classList.contains('active')) {
            this.parentElement.classList.remove('active');
            return;
        }
        jq('.main-menu > .has-children').each(function() {
            this.classList.remove('active');
        });
        this.parentElement.classList.add('active');
    });
    
    jq('#mobile-nav ul a').accessibleClick(function(e) {
        if (windowW >= 992) return;
        let navMenu = document.getElementById('mobile-nav');
        jq('#mobile-nav').toggleClass('cbp-spmenu-open');
        jq('body').toggleClass('push-to-left');
        jq('#showRight').toggleClass('active');
    });    

    jq('.mobile-sub-nav-trigger').accessibleClick(function(evt) {
        // We want to use the accessibleClick method so that the logic surrounding
        // keys is consistent; however, avoid recursion by causing an infinite click loop
        if (evt.type != 'click') {
            jq(this).click();
            return false;
        }
    });   
    
    //Accessible click for Financial Results collapse elements
    jq('.quarterly-results [role=button]').accessibleClick(function(evt) {
        // We want to use the accessibleClick method so that the logic surrounding
        // keys is consistent; however, avoid recursion by causing an infinite click loop
        if (evt.type != 'click') {
            jq(this).click();
            return false;
        }
    });
    
    //Expand/Collapse all button for Financial Results
    var FinancialResultsExpandBtn = jq(".expand-all-quarters");
    var QuarterHeaders = jq(".quarterly-results .header");
    
    FinancialResultsExpandBtn.on('click', function(e) {
        //If elements are collapsed, expand the rest
        if (jq(this).text() == 'Expand All') {
            QuarterHeaders.filter(".collapsed").click();
        } else {
            //Otherwise collapse them all
            QuarterHeaders.filter(":not(collapsed)").click();
        }
    });
    
    QuarterHeaders.on("click", function(e) {
        if (FinancialResultsExpandBtn.length) {
            //Allow for collapse animation to complete
            //setTimeout(functionRef, delay, param1, param2)
            setTimeout(updateExpandBtnText, 200, FinancialResultsExpandBtn, ".quarterly-results .header");
        }
    });
    
    // Allows upload of cover letter via styled link by triggering hidden upload/input field
    jq("#cover_letter").on('click', function(e) {
        e.preventDefault();
        jq("#upload_cover_letter:hidden").trigger('click');
    });
    
    // Make sure all registered marks are superscripts within the .general-wrapper, don't replace ones already superscripted.
    jq('.general-wrapper').find(':not(script, sup, .klaro.cm-as-context-notice *)').contents().filter(function() {
        return this.nodeType === 3;
    }).replaceWith(function() {
        return this.nodeValue.replace(/&reg;|®/gi, '<sup>&reg;</sup>');
    });

    /**
     * Elastic Search Tab Control
     **/
    const delay = 1000; // Time in milliseconds to wait before selecting tab

    // Get current URL
    let currentUrl = window.location.href;
    
    // Defining Active Tab variable
    if (currentUrl.includes("press-releases")) {
        var tabTarget = '#tab-press-releases';
    } else if (currentUrl.includes("sec-filings")) {
        var tabTarget = '#tab-all-sec-filings';
    } else {
        var tabTarget = '#tab-all';
    }
    
    // Execute click
    function selectTab() {
        setTimeout(() => {
            if ( jq(tabTarget).length ) {                                       
               jq(tabTarget).click();               
            }
        }, delay); 
    }    
    selectTab();
    
    // Chart Library Functionality
    jq(".chart-table-expander").on('click', function(e) {
        e.target.classList.toggle('hidden');
        e.target.parentElement.querySelector('.chart-legend').classList.toggle('hidden');
    });
   
   // Remove width from table headers with only a superscript  
    jq(".report .th").each(function(){
        // Extract the innerHTML
        const innerContent = jq(this).html().trim();
        
        // Use a regex to check if content matches <sup> with a number, asterisk, or these wrapped in square brackets
        const regex = /^<sup>(\[\d+\]|\d+|\[\*\]|\*)<\/sup>$/;
        if (regex.test(innerContent)) {
            jq(this).css({
                "width": "0%",
                "padding-left": "0"
            });
        }
    });
    
    /**
     * Accessibility Fix for Radio Inputs
     **/
    let radioLabels = document.querySelectorAll('.eq-radio label');

    radioLabels.forEach(function(radioLabel) {
        radioLabel.setAttribute('tabindex', '0'); // Ensure labels are focusable

        radioLabel.addEventListener('keydown', function(e) {
            // Check if the key pressed is the spacebar
            if (e.key === ' ' || e.keyCode === 32) {
                e.preventDefault();
                let associatedRadio = document.getElementById(this.getAttribute('for'));
                // Check if the associated radio button exists and is not already checked
                if (associatedRadio && !associatedRadio.checked) {
                    associatedRadio.checked = true;
                    associatedRadio.dispatchEvent(new Event('change'));
                }
            }
        });
    });
    // MOBILE MENU TRAP FOCUS
    // Last top-level link (supports split .main-menu--cluster + .main-menu--end markup)
    let lastNavItem = jq('#mobile-nav > ul:last-of-type > li:last-child > a');
    let mobileTrigger = jq('.mobile-nav-trigger');
    // Normal Tab 
    lastNavItem.on('keydown', function(e) {
        if (!e.shiftKey && e.key === 'Tab' && mobileTrigger.hasClass('active')) {
            e.preventDefault();
            mobileTrigger.focus();
        }
    });
    // Shift + Tab
    mobileTrigger.on('keydown', function(e) {
        if (e.shiftKey && e.key === 'Tab' && mobileTrigger.hasClass('active')) {
            e.preventDefault();
            lastNavItem.focus();
        }
    });
    //CCPA Request Form
    jq('#ccpa-request-form input[name="claim"]').change(function(){
        let value = jq(this).val();
        if (value == 'Resident') {
            jq('.show-resident').removeClass('hide');
            jq('.show-representative').addClass('hide');
            jq('#certify_resident').addClass('required');
            jq('#certify_resident').attr('aria-required', 'true');
            jq('.show-representative .conditional-required, #certify_representative').removeClass('required');
            jq('.show-representative .conditional-required, #certify_representative').removeClass('error');
            jq('.show-representative .conditional-required, #certify_representative').removeAttr('aria-required');
        } else if (value == 'Representative') {
            jq('.show-representative').removeClass('hide');
            jq('.show-resident').addClass('hide');
            jq('#certify_resident').removeClass('required');
            jq('#certify_resident').removeClass('error');
            jq('#certify_resident').removeAttr('aria-required');
            jq('.show-representative .conditional-required, #certify_representative').addClass('required');
            jq('.show-representative .conditional-required, #certify_representative').attr('aria-required', 'true');
        }
    });

    if (autorefresh) {
        setTimeout(() => {
            location.reload();
        }, 60000); // Auto reload every minute
    }

    jq('.collapse').on('shown.bs.collapse', function (event) {
        // Get the content element within the collapsed section
        let contentElement = jq(this).find('.text')[0];
        
        if (contentElement) {
            // Check if the content is not in the viewport before scrolling
            if (!isElementInViewport(contentElement)) {
                // Scroll to reveal the content
                contentElement.scrollIntoView({
                    behavior: 'smooth',
                    block: 'end',
                    inline: 'nearest'
                });
            }
        }
    });

    // Numbered navy accordion: focus moves between panel headers with Arrow/Home/End (APG accordion).
    document.addEventListener('keydown', function (e) {
        var trigger = document.activeElement && document.activeElement.closest &&
            document.activeElement.closest('.module-accordion.accordion-numbered-navy .accordion-card-navy__trigger');
        if (!trigger || document.activeElement !== trigger) {
            return;
        }
        if (e.altKey || e.ctrlKey || e.metaKey) {
            return;
        }
        var container = trigger.closest('.collapse-section.accordion-card-navy');
        if (!container) {
            return;
        }
        var triggers = Array.prototype.slice.call(container.querySelectorAll('.accordion-card-navy__trigger'));
        if (triggers.length < 2) {
            return;
        }
        var ix = triggers.indexOf(trigger);
        if (ix < 0) {
            return;
        }
        var nextIx = -1;
        if (e.key === 'ArrowDown') {
            nextIx = (ix + 1) % triggers.length;
        } else if (e.key === 'ArrowUp') {
            nextIx = (ix - 1 + triggers.length) % triggers.length;
        } else if (e.key === 'Home') {
            nextIx = 0;
        } else if (e.key === 'End') {
            nextIx = triggers.length - 1;
        }
        if (nextIx < 0 || nextIx === ix) {
            return;
        }
        e.preventDefault();
        triggers[nextIx].focus();
    });

    // Initialize dialogs
    let eq_dialogs = new EqDialog();
    eq_dialogs.init();
}); // end document.ready

// Function to check if an element is in the viewport
function isElementInViewport(el) {
    var rect = el.getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
}

// Adds asterisk to the labels of required form inputs
function addRequiredAsteriskToLabels() {
    jq("form .required").siblings("label").each(function () {
        let currentText = jq(this).text();
        jq(this).text(currentText + "*");
    });
}

/**
 * addCustomErrorFormHandlers
 *
 * Sets up custom error handling for forms, specifically targeting required 
 * checkboxes and radio button groups. Displays error messages and applies
 * border styling to elements that fail validation. Enhances accessibility by
 * updating ARIA attributes based on user interactions.
 *
 * - Applies different border colors for elements within dark-themed sections.
 * - Adds or removes error messages and styles based on validation results.
 * - Updates ARIA attributes for better accessibility.
 */

function addCustomErrorFormHandlers() {
    const BORDER_COLOR_LIGHT = '#D40033';
    const BORDER_COLOR_DARK = '#FA003A';

    // Listen for form submission
    jq('form').on('submit', function(e) {
        jq('ul.checkboxes.required, ul.radios.required').each(function() {
            let type = jq(this).hasClass('checkboxes') ? 'checkbox' : 'radio';
            let borderColor = jq(this).closest('.dark').length > 0 ? BORDER_COLOR_DARK : BORDER_COLOR_LIGHT;

            // Check if any input of the correct type in this group is checked
            if (jq(this).find('input[type="' + type + '"]:checked').length === 0) {
                jq(this).css('border', '1px solid ' + borderColor);

                // Add error message if it does not already exist
                if (jq(this).siblings(".eq-error").length === 0) {
                    jq(this).after('<span class="eq-error">This field is required</span>');
                }
            } else {
                // Remove the border and error message if any input is checked
                jq(this).css('border', '');
                jq(this).siblings(".eq-error").remove();
            }
        });
    });

    // Event handler for changes to checkboxes and radio buttons in all groups
    jq(document).on('change', 'ul.checkboxes input[type="checkbox"], ul.radios input[type="radio"]', function() {
        let ul = jq(this).closest('ul.checkboxes, ul.radios');
        
        // Update ARIA attributes for accessibility
        if (jq(this).attr('type') === 'radio') {
            // Set aria-checked for all radio buttons in the group
            ul.find('input[type="radio"]').attr('aria-checked', 'false');
            jq(this).attr('aria-checked', 'true');
        } else {
            jq(this).attr('aria-checked', this.checked);
        }

        // Check if any input in this group is checked
        if (ul.find('input:checked').length > 0) {
            // If an input is checked, remove the border and error message
            ul.css('border', '');
            ul.siblings(".eq-error").remove();
        }
    });

    // Initialize ARIA attributes on page load
    jq('ul.checkboxes input[type="checkbox"], ul.radios input[type="radio"]').each(function() {
        jq(this).attr('aria-checked', this.checked);
    });
}

// Call the function to setup event handlers once the document is ready
jq(document).ready(function() {
    addCustomErrorFormHandlers();
});

//SMOOTH SCROLL

// Scrolling when accessing an URL with a hash in there
jq(window).on('load', function () {
    let windowLocationHash = window.location.hash;
    if (windowLocationHash.length) {
        let hashElement = jq(windowLocationHash);
        if (hashElement.length) {
            window.scrollTo(0, 0);
            smoothScrollToHash(windowLocationHash);
        }
    }
});

// Smooth scroll animation when a link containing # in the href is clicked
jq('a[href*="#"]').on('click', function(event) {
    // Check for any anchor links we want to ignore
    if (jq(this).hasClass('chart-legend-trigger') || 
        jq(this).hasClass('accordion-btn') || 
        jq(this).hasClass('eq-dialog') ||
        jq(this).hasClass('footnote-anchor') ||
        jq(this).hasClass('footnote-return') ||
        jq(this).closest('.tab-header').length) {

        return; // Exit the function early if ignored links are found
    }

    if (this.hash === "") {
        return;
    }

    // Only intercept same-page hash links; cross-page links (e.g. /resources#key-terms) navigate normally.
    var linkPath = this.pathname.replace(/\/$/, '') || '/';
    var currentPath = window.location.pathname.replace(/\/$/, '') || '/';
    if (linkPath !== currentPath) {
        return;
    }

    event.preventDefault();

    let hash = this.hash;
    let el = document.getElementById(hash.slice(1));
    if (el && el.classList.contains('panel-collapse')) {
        setTimeout(function () {
            smoothScrollToHash(hash);
        }, 100);
    } else {
        smoothScrollToHash(hash);
    }
});
function smoothScrollToHash(hash) {
    if (hash.length) {
        let hashElement = jq(hash);
        if (hashElement.length) {
            let offset = 0;
            let header = jq('#header');
            let subNav = jq('.sub-navigation');
            if (header.length) {
                offset += header.outerHeight();
            }
            if (subNav.length) {
                offset += subNav.outerHeight();
            }
            jq('html,body').animate({
                scrollTop: hashElement.offset().top - offset
            }, 800);
        }
    }
}

//Check if any target elements are collapsed
function elementsAreCollapsed(selector = "[data-toggle='collapse']") {
    if (jq(selector + '.collapsed').length) {
        return true;
    } else {
        return false;
    }
}

function updateExpandBtnText(btn, collapseTarget) {
    if (!btn) {
        return;
    }
    if (elementsAreCollapsed(collapseTarget)) {
        btn.text('Expand All');
    } else {
        btn.text('Collapse All');
    }
}

// Checkbox Groups
var update_sec_checkboxes = function () {
    if (jq("#ir-sec-all").is(":checked")) {
        jq(".ir-sec-sub").prop("checked", true).prop("disabled", true);
    } else {
        jq(".ir-sec-sub").prop("disabled", false).prop("checked", false);
    }
}
jq("#ir-sec-all").change(update_sec_checkboxes);
if (jq("#ir-sec-all").is(":checked")) {
    jq(".ir-sec-sub").prop("checked", true).prop("disabled", true);
}

// Timeline
var $timelineEl = jq(".module-timeline");
if ($timelineEl.length) {
    var timeline = {
        resizePoints: function () {
            if (jq(window).outerWidth() < 768) return;
            jq(".point-wrapper").each(function () {
                  var point = jq(this).find(".point");
                  jq(this).css("height", point.outerHeight()/1.2);
                });
        }
    };
    // Once we"re done resizing, calculate the height for the points.
    var resizeTimer;
    jq(window).on("resize", function (e) {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(timeline.resizePoints, 250);
    });
    timeline.resizePoints();
}
//Add Class to body if page has scrollbar
jq(window).on("resize", function (e) {
    if (jq(document).width() < jq(window).outerWidth()) { 
        jq('body').addClass('scrollbar');
    } else {
        jq('body').removeClass('scrollbar');
    }
});
// Scroll More CTA templates
var scrollMore = document.getElementById("scroll-more-alt");
if (scrollMore) {
    jq(scrollMore).accessibleClick(function (e) {
        e.preventDefault();
        var target = jq("#scroll-more-anchor");
        jq("html,body").animate({
            scrollTop: target.offset().top - jq("#header").height()
        }, "slow");
    });
}
/**
 * Balance Sheet Page - Income Statement Page - Cash Flow Page
 * 
 * Replaces <a> elements within report table with <span> elements.
 * Removes 'href' and 'onclick' attributes from these elements &
 * adds the original 'a' class back to it.
 */
document.addEventListener('DOMContentLoaded', () => {
    if (document.querySelector('.report')) {
        // Find the table with class 'report'
        const reportTable = document.querySelector('.report');
        
        if (reportTable) {
            // Find all <td> elements containing <a> elements
            const tdWithLinks = reportTable.querySelectorAll('td a');
            
            // Transform each <a> into a <span>
            tdWithLinks.forEach(aElement => {
                const span = document.createElement('span');
                span.innerHTML = aElement.innerHTML;
                aElement.parentNode.replaceChild(span, aElement);
                span.classList.add("a");
            });
        }
    }
});

// Accesibility Form
let formCounter = 0;
jq('.add-request').accessibleClick(function(){
    formCounter++;
    let newFields = '<div class="info-block">' +
                	    '<div class="form-group">' +
                	        '<label for="url-'+ formCounter +'">URL of requested document or webpage:</label>' +
                	        '<input type="text" name="url-'+ formCounter +'" id="url-'+ formCounter +'" value="" class="required form-control" placeholder="ex. https://www.website.com/page" />' +
                	    '</div>' +
                	    '<div class="form-group">' +
                	        '<label for="description-'+ formCounter +'">Description of request or issue related to URL:</label>' +
                	       '<textarea name="description-'+ formCounter +'" id="description-'+ formCounter +'" value="" class="required form-control" placeholder="Enter a description of your request or issue related to the URL inputted above"></textarea>' +
                	    '</div>' +
            	    '</div>';
    jq('.request-info').append(newFields);
    jq('#url-' + formCounter).focus();
});

/**
 * Global Table Wrapper
 * 
 * If a table is too wide and moves off screen, this will add the "scroll" class
 * and shadow classes for accessibility.
 */
function applyScrollToTables() {
    jq('.table-figure').each(function() {
        let wrap = jq(this).closest('.table-wrapper');
        if (jq(this).find('table').outerWidth() > jq(this).outerWidth()) {
            wrap.addClass('scroll');
            wrap.addClass('shadow-right');
            let top = Math.round(jq(this).find('table').offset().top - wrap.offset().top);
            wrap.find('.left-shadow-block').css('top', top + 'px');
            wrap.find('.right-shadow-block').css('top', top + 'px');
        } else {
            wrap.removeClass('scroll');
            wrap.removeClass('shadow-right shadow-left')
        }
    });
}
/**
 * Global Table Wrapper - Update Shadows
 * 
 * This will update the "shadow" classes in the table wrapper
 * On load, the "shadow-right" class is in the table wrapper by default
 * If the user scrolls, it will add the "shadow-left shadow-right" classes
 * If the user scrolls all the way to the right, it will keep "shadow-left" but remove "shadow-right"
 */
function updateShadowsInTables() {
    jq(".scroll .table-figure").each(function() {
        let wrap = jq(this).closest('.table-wrapper');
        var cur = Math.ceil(jq(this).scrollLeft());
        var max = this.scrollWidth - jq(this).parent().width();

        if (cur == 0) {
            wrap.addClass('shadow-right').removeClass('shadow-left');
        } else if (cur >= max) {
            wrap.addClass('shadow-left').removeClass('shadow-right');
        } else {
            wrap.addClass('shadow-right shadow-left');
        }
    });
}
/**
 * Global - Decorative Image Alt Check
 * 
 * This will check all images across the site to see if the image has a
 * empty or missing alt attribute. If so, aria-hidden="true" will be set.
 */
jq('img').each((ind, el) => {
    // Check if the image has empty or no alt attribute
    if (!jq(el).attr('alt') || jq(el).attr('alt').trim() === '') {
        // If the alt text is empty or not present, set aria-hidden="true"
        jq(el).attr('aria-hidden', 'true');
    }
});

/**
 * Row Scripts
 * 
 * These are specific to rows in template
 */
 
// Row News Financial Results Event
jq(document).ready(function() {
    if (jq(".row-news-slider").length) {
       jq(".row-news-slider").slick(JSON.parse(document.getElementById("rowNewsSlickOptions").innerText));
       
        var sliderElement = jq('.row-news-slider');
        var progressBar = jq('.progress-bar-container .progress-bar');
    
        sliderElement.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
            var calc = ( (nextSlide+1) / (slick.slideCount) ) * 100;
            
            progressBar
                .css('background-size', calc + '% 100%')
                .attr('aria-valuenow', calc );
        });
    
        jq('.slick-prev').on('click', function() {
            sliderElement.slick('slickPrev');
        });
    
        jq('.slick-next').on('click', function() {
            sliderElement.slick('slickNext');
        });
    }
    // Scroll more home hero button
    let scrollMore = document.getElementById("scroll-more-midtown");
    if (scrollMore) {
        jq(scrollMore).accessibleClick(function (e) {
            e.preventDefault();
            let target = jq("#scroll-more-anchor");
            jq("html,body").animate({
                scrollTop: target.offset().top - jq("#header").height()
            }, "slow");
        });
    }
});

/**
 * Footnotes Functionality
 */
const createSuperscriptLink = (id) => `<sup><a href="#footnoteDesc${id}" aria-describedby="footnoteDesc${id}" tabindex="0" data-footnote="${id}" class="span-asterisk">*</a></sup>`;
let footnoteCounter = 0;
function processFootnotesInSection(stats, footnotes) {
    // Processing of footnotes
    footnotes.forEach(footnote => {
        if (footnote.textContent.trim().startsWith('*')) {
            footnote.outerHTML = `<p id="footnoteDesc${++footnoteCounter}" class="footnote-desc" aria-label="Footnote ${footnoteCounter}" role="status" tabindex="0">${footnote.innerHTML}</p>`;
        }
    });
    // Link asterisks in stats to footnotes
    stats.forEach(stat => {
        let localCounter = footnoteCounter - 1;
        stat.innerHTML = stat.innerHTML.replace(/\*/g, () => createSuperscriptLink(++localCounter));
    });
}
function processAllFootnotes() {
    const sections = document.querySelectorAll('.container');
    sections.forEach(section => {
        const stats = section.querySelectorAll('.stat p, .stat-box p');
        const footnotes = section.querySelectorAll('.financial-disclaimer .financial-text p, .source p');
        processFootnotesInSection(stats, footnotes);
    });
}
document.addEventListener('DOMContentLoaded', processAllFootnotes);
